export const MainConfig = {
  AppDetails: {
    app_name: "KyaRide",
    app_description: "KyaRide Sharing App",
    app_identifier: "uk.co.reparle.kyaride.fleet",
    ios_app_version: "2.3",
    android_app_version: 23
  },
  FirebaseConfig: {
    apiKey: "AIzaSyBFYtgSF_thd2wrwrCTN37ATV2osGP8f90",
    authDomain: "fleet-56441.firebaseapp.com",
    databaseURL: "https://fleet-56441-default-rtdb.firebaseio.com",
    projectId: "fleet-56441",
    storageBucket: "fleet-56441.appspot.com",
    messagingSenderId: "400112458527",
    appId: "1:400112458527:web:ce0d224d33f660ff9dee2a",
    measurementId: "G-WWT0MK7PH1"
  },
  Google_Map_Key: "AIzaSyA3Nf7Md55vojg1ims8vT29LC-GB4Hhh9o",
  facebookAppId: "836519067146633"
}
